export const DEFAULT_NOTE_DATA = {
  'note-status': null,
  'note-subStatus': null,
  note: ''
};

export const NOTES_QUERY_SORT = { ['sort.col']: 'createdOn', ['sort.dir']: 2 };
